import {
  ACCOUNT_STATEMENTS_DEMO,
  type AccountStatementsData,
} from 'src/page-components/Accounts/AccountStatementsTab/accountStatementsDemoData'

/**
 * Single data seam for the card-detail Statements tab (EX-40600).
 *
 * Mirrors `useCardDetailHeroData` for the sibling Card Management surface, and
 * carries the same rule: section components MUST read through this hook rather
 * than importing `ACCOUNT_STATEMENTS_DEMO` directly, so wiring real data touches
 * this file and nothing else.
 *
 * EVERYTHING RETURNED HERE IS FABRICATED — deliberately, as a demo surface for
 * selected organizations while the real statements endpoint is built. Keep the
 * exposure in mind when changing the gates: unlike the hero, which only a client
 * flag opens, this tab is ALSO opened by the server capability
 * `READ_PHYSICAL_CARD_STATEMENTS` (see `isUpdatedCardStatementsEnabled`), so
 * enrolling an organization on the backend is by itself enough to show it
 * invented statements, payments, and due dates. That is the intended rollout,
 * but it means the audience is set by backend enrollment rather than by anything
 * visible in this repo — widen it only on purpose.
 *
 * The return groups by SOURCE, not by consumer: `payments` and `statements` are
 * separately fetched in any plausible contract. Wiring real data means replacing
 * each group with its own query here — keeping their failure and refresh windows
 * isolated — while the section components and their tests stay untouched.
 * Sections should destructure only the group they use, so a group gaining
 * loading/error state later is a change to its own consumers and no one else's.
 *
 * @param _creditCardId - The card whose statements to read. Unused while the
 *   data is a frozen constant, but taken now so the call site already passes
 *   what every real query will key on.
 */
export const useAccountStatementsData = (
  _creditCardId: string | undefined,
): AccountStatementsData => ACCOUNT_STATEMENTS_DEMO
